export function getFileFormat(contentType: string) {
  if (contentType.includes('pdf')) {
    return 'PDF';
  }

  if (contentType.includes('jpeg')) {
    return 'JPG';
  }

  if (contentType.includes('png')) {
    return 'PNG';
  }

  if (contentType.includes('xml')) {
    return 'XML';
  }

  if (contentType.includes('zip')) {
    return 'ZIP';
  }

  return '';
}
